<script>
    import solicitacaoDoacaoRealizadasServico from '../servico';

    import $ from 'jquery';
    import 'select2';
    import 'select2/dist/js/i18n/pt-BR';
    import Radio from '~componentes/Radio.vue';

    export default {
        components: { Radio },
        data() {
            return {
                doacao: this.camposDoacao(),
                doacoes: [],
                inscricoes: [],
                carregando: false,
                filtros: this.camposFiltros(),
                animated: true,
                configuracao: this.$storage.configuracao(),
                usuario: this.$storage.usuario(),
                pesquisou: false,
            }
        },
        computed: {
        },
        methods: {
            camposDoacao() {
                return {
                    idDoacao: '',
                    nomeDoacao: '',
                }
            },
            camposFiltros() {
                return {
                    idDoacao: '',
                    idDoacaoInt: 0,
                    mostrarInscricoes: '0',
                };
            },
            limparFiltros() {
                this.filtros = this.camposFiltros();
                this.$nextTick(() => {
                    $('#doacao').val('0');
                    $('#doacao').trigger('change.select2');
                });

                this.pesquisou = false;
                this.inscricoes = [];
            },
            lista(pagina = 1) {
                this.carregando = true;

                return solicitacaoDoacaoRealizadasServico.lista(pagina, this.filtros)
                    .then(res => {
                        this.carregando = false;
                        this.pesquisou = true;
                        this.inscricoes = res.body.registros;
                    });
            },
            mostrarEsconderFiltro(e) {
                if (!$(e.target).hasClass('fa-chevron-down') && !$(e.target).hasClass('fa-chevron-up')) {
                    $('.collapse-link').trigger('click');
                }
            },
            async listaDeDoacoes() {
                return solicitacaoDoacaoRealizadasServico
                    .listaDeDoacoes()
                    .then(doacoes => {
                        this.doacoes = doacoes;
                    });
            },
            filtrar() {
                this.lista();
            },
            gerarExcel() {
                return solicitacaoDoacaoRealizadasServico.listagemExcel(this.filtros)
                    .then(arquivo => {
                        $('#gerar-excel').button('reset');

                        if (arquivo === '') {
                            this.$swal('', 'Nenhum resultado encontrado.', 'info');
                        } else {
                            arquivo.download();
                        }
                    })
                    .catch(erro => {
                        $('#gerar-excel').button('reset');

                        this.$mensagemErro(erro, 'Erro ao gerar relatório.');
                    });
            },
            setarDoacao(id) {
                this.doacoes.map(doacao => {
                    if (doacao.idDoacaoInt == id) {
                        this.$set(this, 'doacao', doacao)
                        this.$set(this.filtros, 'idDoacao', doacao.idDoacao)
                        this.$set(this.filtros, 'idDoacaoInt', doacao.idDoacaoInt)
                    }
                });
            },
        },
        created() {
            if (this.$route.params.filtrosBag) {
                this.$set(this.filtros, 'idDoacao', this.$route.params.filtrosBag.idDoacao)
                this.$set(this.filtros, 'idDoacaoInt', this.$route.params.filtrosBag.idDoacaoInt)

                this.listaDeDoacoes()
                    .then(_ => {
                        this.setarDoacao(this.filtros.idDoacaoInt)
                        $('.ibox').removeClass('collapsed');
                    });
            }

            this.$root.botaoAcaoMostrar = false;
            this.$root.botaoRetrocederMostrar = false;
        },
        mounted() {
            this.$root.botaoAcaoMostrar = false;
            this.$root.botaoRetrocederMostrar = false;
            this.$root.tituloDaPagina = 'Doações Realizadas - Lista';

            this.listaDeDoacoes();
            $('.ibox').removeClass('collapsed');

            const _this = this;

            $('#doacao').select2({
                theme: "bootstrap",
                placeholder: "Selecione...",
                language: "pt-BR"
            })
                .change(function (e) {
                    _this.$set(_this.filtros, 'idDoacaoInt', this.value);
                    _this.setarDoacao(this.value)
                });

            if (this.$route.params.filtrosBag) {
                this.$set(this.filtros, 'idDoacao', this.$route.params.filtrosBag.idDoacao)
                this.$set(this.filtros, 'idDoacaoInt', this.$route.params.filtrosBag.idDoacaoInt)

                this.listaDeDoacoes()
                    .then(_ => {
                        this.setarDoacao(this.filtros.idDoacaoInt)
                        $('.ibox').removeClass('collapsed');
                    });
            }
        },
        watch: {

        },
    }
</script>

<style scoped>
    .checked {
        font-size: 1.40em;
        color: #1d9d74;
    }

    .cancelado {
        font-size: 1.40em;
        color: #ed5565;
    }
</style>

<template>

    <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">

        <div class="row">
            <div class="col-lg-12">
                <div class="ibox collapsed float-e-margins">
                    <div class="ibox-title pointer" @click="mostrarEsconderFiltro">
                        <h5>Filtrar lista <small class="m-l-sm">Clique para mostrar ou esconder os filtros</small></h5>

                        <div class="ibox-tools">
                            <span class="collapse-link">
                                <i class="fa fa-chevron-up"></i>
                            </span>
                        </div>
                    </div>
                    <div class="ibox-content">

                        <div class="row">
                            <div class="col-xs-8">
                                <div class="form-group">
                                    <label class="control-label" for="doacao">Doação</label>

                                    <select id="doacao"
                                            class="form-control"
                                            v-model="filtros.idDoacaoInt">
                                        <option value="0">Selecionar</option>
                                        <option :value="doacao.idDoacaoInt" v-for="(doacao, index) in doacoes">{{ doacao.nomeDoacao }}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-xs-4">
                                <div class="form-group">
                                    <label class="control-label block">Mostrar inscrições</label>

                                    <radio v-model="filtros.mostrarInscricoes"
                                           selected-value="0"
                                           type="success"
                                           :inline="true"
                                           class="margin-right-10">
                                        Todas
                                    </radio>
                                    <radio v-model="filtros.mostrarInscricoes"
                                           selected-value="1"
                                           type="success"
                                           :inline="true"
                                           class="margin-right-10">
                                        Recebidas
                                    </radio>
                                    <radio v-model="filtros.mostrarInscricoes"
                                           selected-value="2"
                                           type="success"
                                           :inline="true">
                                        Em aberto
                                    </radio>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12">
                                <div class="form-group no-margins">
                                    <button type="button" class="btn btn-primary no-margins" @click="filtrar">
                                        <i class="fa fa-search"></i>
                                        Filtrar
                                    </button>
                                    <button type="button" class="btn btn-default no-margins" @click="limparFiltros">
                                        <i class="fa fa-eraser"></i>
                                        Limpar filtros
                                    </button>
                                    <button id="gerar-excel"
                                            type="button"
                                            class="btn btn-primary"
                                            @click="gerarExcel"
                                            data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
                                        <i class="fa fa-table"></i>
                                        Gerar listagem em excel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="ibox-footer" v-if="inscricoes.length > 0">

                        <div class="table-responsive">
                            <table class="table table-bordered table-column-code table-column-action">
                                <thead>
                                  <tr>
                                    <th class="text-center">Código</th>
                                    <th class="text-center">Recebido</th>
                                    <th>Data inscrição</th>
                                    <th>Categoria</th>
                                    <th>Nome</th>
                                    <th>Email</th>
                                    <th>Telefone</th>
                                    <th>Valor</th>
                                  </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(inscricao, index) in inscricoes">
                                        <td class="text-center">{{ inscricao.idInscricao || '---' }}</td>
                                        <td class="text-center"><i class="fa fa-check-circle-o checked" v-if="inscricao.recebido"></i></td>
                                        <td>{{ inscricao.dataInscricao || '---' }}</td>
                                        <td>{{ inscricao.selecaoCategoria || '---' }}</td>
                                        <td>{{ inscricao.nome || '---' }}</td>
                                        <td>{{ inscricao.email || '---' }}</td>
                                        <td>{{ inscricao.celular ? inscricao.celular : inscricao.telefone  || '---' }}</td>
                                        <td>{{ inscricao.valor | formatarNumero }}</td>
                                    </tr>
                                    <tr v-show="carregando">
                                        <td colspan="13">
                                            <i class='fa fa-spinner fa-pulse'></i> Carregando...
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="ibox-footer" v-if="inscricoes.length == 0 && pesquisou">
                        <div class="group">
                            <h4 class="text-center">Sem doações</h4>
                        </div>

                        <div class="hr-line-dashed margin-top-5"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-doacao-realizadas/componentes/SolicitacaoDoacaoRealizadasLista.vue